import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Injectable({
    providedIn: 'root'
})


export class InProgressService {
    mainLoaderCount: number = 0;

    constructor(private translateService: TranslateService) {
    }

    start(parentDiv: any = null, topValue: any = null) {
        if (parentDiv != null) {
            var loadingTranslate = this.translateService.instant(['Loading...']);
            var parentSelectorString = parentDiv.indexOf('body') !== -1 ? 'body' : parentDiv;
            var parent = document.querySelector(parentSelectorString);
            if (parent != null) {
                var id = parentDiv.replace("#", "anime-");
                if (parentDiv == id) {
                    id = 'main-loader'
                }
                var inProgressDetailElementString = "";
                if (parentDiv.indexOf('body') === -1) {
                    inProgressDetailElementString = '<div id="' + id +
                        '" class="inProgressDetail" style="visibility: hidden;"><h4><span class="spinner-border " style="width: 4rem; height: 4rem; color:#0057A3"></span>&nbsp;<b>' + loadingTranslate["Loading..."] + '</b></h4></div>';
                } else {
                    var inprogressSpinnerElements = document.querySelectorAll('[aria-label="inProgressSpinner"]');
                    if (inprogressSpinnerElements.length === 0) {
                        this.mainLoaderCount = 1;
                        inProgressDetailElementString = '<div aria-label="inProgressSpinner" id="' + id + '" class="inProgressClass"><h4><span class="spinner-border " style="width: 4rem; height: 4rem; color:#0057A3"></span>&nbsp;<b>' + loadingTranslate["Loading..."] + '</b></h4></div>';
                    }
                    else {
                        inprogressSpinnerElements[0].id = id;
                        this.mainLoaderCount++;
                    }
                }
                parent.insertAdjacentHTML('beforeend', inProgressDetailElementString);
                setTimeout(() => {
                    if (parentDiv.indexOf('body') === -1) {
                        var element: any = document.getElementById(id);
                        if (parent !== undefined && element !== undefined) {
                            element.style.height = parent.clientHeight + "px";
                            element.style.width = parent.clientWidth + "px";
                            let modalDialog = document.getElementsByClassName('modal-dialog');
                            if ((modalDialog != null && modalDialog.length > 0) || topValue != null) {
                                element.style.top = '0';
                            }
                            element.children[0].style.marginTop = (parent.clientHeight / 2).toString() + 'px';
                            element.style.visibility = 'visible';
                        }
                    }
                }, 500);
            }
        }
    }

    complete(parentDiv: any = null) {
        if (parentDiv != null) {
            setTimeout(() => {
                var id = parentDiv.replace("#", "anime-");
                var isLoaderFromBodyElement = false;
                if (parentDiv == id) {
                    id = '#main-loader'
                    isLoaderFromBodyElement = true;
                }
                else {
                    id = "#" + id;
                }
                var animeElement = document.querySelector(id);
                if (animeElement != null) {
                    if((isLoaderFromBodyElement && this.mainLoaderCount > 1)) {
                        this.mainLoaderCount--;
                    }
                    else {
                        animeElement.remove();
                    }
                }
            }, 500);
        }
    }
}